import { FormControl, FormHelperText, FormLabel, Input } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import { BulkFileConfig } from "@nens/ldo/api-v1";

interface ExportBulkFileFieldsProps {
  readonly: boolean;
  value: BulkFileConfig;
  onChange: (e: Partial<BulkFileConfig>) => void;
  formErrorKeys: string[];
}

export function ExportBulkFileFields({
  readonly,
  value,
  onChange,
  formErrorKeys,
}: ExportBulkFileFieldsProps) {
  const stripXlsx = (s: string) => {
    return s.endsWith(".xlsx") ? s.slice(0, s.length - 5) : s;
  };

  const addXlsx = (s: string) => {
    return s.endsWith(".xlsx") ? s : s + ".xlsx";
  };

  return (
    <FormControl my="4">
      <FormLabel fontWeight="semibold">
        <FormattedMessage
          id="pages.export_scenarios.new.excel_filename"
          defaultMessage='Excel filename (without ".xlsx" extension)'
        />
      </FormLabel>
      <Input
        type="text"
        onChange={(e) => onChange({ excel_file_name: addXlsx(e.target.value) })}
        value={stripXlsx(value.excel_file_name)}
        isReadOnly={readonly}
      />
      {!readonly ? (
        <FormHelperText>
          *<FormattedMessage id="misc.required_field" defaultMessage="Required field" />
        </FormHelperText>
      ) : null}
      {formErrorKeys.includes("excel_file_name") ? (
        <FormHelperText color="red.500">
          <FormattedMessage
            id="pages.export_scenarios.new.excel_filename_error"
            defaultMessage="Excel filename is required"
          />
        </FormHelperText>
      ) : null}
    </FormControl>
  );
}
